const CHUNK_RELOAD_KEY = "chunkReloadAttempt"
const CHUNK_RELOAD_COOLDOWN_MS = 10_000

const CHUNK_LOAD_ERROR_PATTERNS = [
    "Failed to fetch dynamically imported module",
    "Importing a module script failed",
    "error loading dynamically imported module",
    "Unable to preload CSS",
]

export function isChunkLoadError(reason: unknown): boolean {
    const message = reason instanceof Error ? reason.message : typeof reason === "string" ? reason : ""

    if (!message) {
        return false
    }

    return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => message.includes(pattern))
}

/** Reload once after a deploy invalidated hashed asset URLs. */
export function reloadForStaleAssets(): boolean {
    const lastAttempt = parseInt(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? "0", 10)
    const now = Date.now()

    if (lastAttempt && now - lastAttempt < CHUNK_RELOAD_COOLDOWN_MS) {
        return false
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
    window.location.reload()
    return true
}
